import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "@angular/router";
var CookieConsentService = /** @class */ (function () {
    function CookieConsentService(cookieService, router) {
        this.cookieService = cookieService;
        this.router = router;
    }
    CookieConsentService.prototype.canActivate = function (route, state) {
        this.checkCookieConsent();
        return true;
    };
    CookieConsentService.prototype.checkCookieConsent = function () {
        var catalogries = this.getCookieConsent();
        var allCookie = this.cookieService.getAll();
        // console.log(allCookie)
        var consentResult = [];
        for (var i = 1; i < catalogries.length; i++) {
            var c = catalogries[i].split(':');
            consentResult.push(c[1]);
            this.manageCookie(c, allCookie);
        }
        return consentResult;
    };
    CookieConsentService.prototype.checkGoogleTag = function () {
        var catalogries = this.getCookieConsent();
        for (var i = 1; i < catalogries.length; i++) {
            var c = catalogries[i].split(':');
            if (c[0] === 'C0004') {
                return c[1];
            }
        }
        return '0';
    };
    CookieConsentService.prototype.getCookieConsent = function () {
        var consent = this.cookieService.get('OptanonConsent');
        if (consent === '') {
            return [];
        }
        var cookie = consent.split('&');
        for (var g in cookie) {
            if (cookie[g].match('groups')) {
                var catalogries = cookie[g].split(',');
                return catalogries;
            }
        }
        return [];
    };
    CookieConsentService.prototype.manageCookie = function (c, allCookie) {
        // if c === '0' then not consent // need to delete cookie
        // i == 2 = Performance Cookies (_gat_UA-, _gid, _ga)
        // i == 3 = Functional Cookies (__cfduid)
        // i == 4 = Targeting Cookies (_fbp, fr, _gat_gtag_xxxxxxxxxxxxxxxxxxxxxxxxxxx)
        // i == 5 = Social Media Cookies ()
        for (var o in allCookie) {
            if (allCookie.hasOwnProperty(o)) {
                console.log(o);
                if (c[0] === 'C0002' && c[1] === '0') {
                    if (o.match(/_gat_UA/) || o === '_gid' || o === '_ga') {
                        this.cookieService.delete(o);
                        this.cookieService.delete(o, '/', '.one-asset.com');
                    }
                }
                else if (c[0] === 'C0003' && c[1] === '0') {
                    if (o === '__cfduid') {
                        this.cookieService.delete(o);
                        this.cookieService.delete(o, '/', '.one-asset.com');
                    }
                }
                else if (c[0] === 'C0004' && c[1] === '0') {
                    if (o.match(/_gat_gtag/) || o === '_fbp' || o === 'fr') {
                        this.cookieService.delete(o);
                        this.cookieService.delete(o, '/', '.one-asset.com');
                    }
                }
            }
        }
    };
    CookieConsentService.ngInjectableDef = i0.defineInjectable({ factory: function CookieConsentService_Factory() { return new CookieConsentService(i0.inject(i1.CookieService), i0.inject(i2.Router)); }, token: CookieConsentService, providedIn: "root" });
    return CookieConsentService;
}());
export { CookieConsentService };
